import { primaryKey, headerCode, inputType, required, length, order, pattern, editable, Describer, GceEntity, relation, currency } from './gce-management';
import { GceInvoicePerson } from './gce-invoice-person';
import { PermissionService } from '../../services/permission.service';

export class GceInvoiceDms extends GceEntity {

    @headerCode('GCE.GCEINVOICE.MESE')
    @inputType('date')
    @order(1)
    mese: Date | string;
    @headerCode('GCE.GCEINVOICE.IDFATTURAZIONE')
    @inputType('select')
    @relation("GceInvoicePerson", { columnRel: 'idfatturazione', columnDescr: ['descrizione', 'piva'] })
    @order(2)
    idfatturazione: number;
    @headerCode('GCE.GCEINVOICE.TS_CALCOLO')
    @inputType('datetime')
    @order(3)
    ts_calcolo: Date | string;
    @headerCode('GCE.GCEINVOICE.flg_conferma_hr')
    @inputType('boolean')
    @order(4)
    flg_conferma_hr: boolean;
    @headerCode('GCE.GCEINVOICE.user_conferma_hr')
    @inputType('text')
    @editable(true)
    @order(5)
    user_conferma_hr: string;
    @headerCode('GCE.GCEINVOICE.ts_conferma_hr')
    @inputType('date')
    @order(6)
    ts_conferma_hr: Date | string;
    @headerCode('GCE.GCEINVOICE.flg_cliniche_confermate')
    @inputType('boolean')
    @order(7)
    flg_cliniche_confermate: boolean;
    @headerCode('GCE.GCEINVOICE.idarea')
    @inputType('select')
    @length(16)
    @relation("GceArea", { columnRel: 'AreaId', columnDescr: ['AreaDescrizione'] })
    @required()
    @order(8)
    idarea: number;
    @headerCode('GCE.GCEINVOICE.importo_fisso_dms_mensile_calc')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(9)
    importo_fisso_dms_mensile_calc: number;
    @headerCode('GCE.GCEINVOICE.importo_fisso_dms_mensile_hr')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(10)
    importo_fisso_dms_mensile_hr: number;
    @headerCode('GCE.GCEINVOICE.importo_target_produzione_mensile_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(11)
    importo_target_produzione_mensile_area: number;
    @headerCode('GCE.GCEINVOICE.importo_produzione_mensile_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(12)
    importo_produzione_mensile_area: number;
    @headerCode('GCE.GCEINVOICE.perc_produzione_mensile_area')
    @inputType('number')
    @editable(true)
    @order(13)
    perc_produzione_mensile_area: number;
    @headerCode('GCE.GCEINVOICE.importo_bonus_dms_mensile_calc')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(14)
    importo_bonus_dms_mensile_calc: number;
    @headerCode('GCE.GCEINVOICE.importo_bonus_dms_mensile_hr')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(15)
    importo_bonus_dms_mensile_hr: number;
    @headerCode('GCE.GCEINVOICE.importo_target_mensile_personale')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(16)
    importo_target_mensile_personale: number;
    @headerCode('GCE.GCEINVOICE.importo_produzione_mensile_personale')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(17)
    importo_produzione_mensile_personale: number;
    @headerCode('GCE.GCEINVOICE.perc_produzione_mensile_personale')
    @inputType('number')
    @editable(true)
    @order(18)
    perc_produzione_mensile_personale: number;
    @headerCode('GCE.GCEINVOICE.importo_variabile_dms_mensile_calc')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(19)
    importo_variabile_dms_mensile_calc: number;
    @headerCode('GCE.GCEINVOICE.importo_variabile_dms_mensile_hr')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(20)
    importo_variabile_dms_mensile_hr: number;
    @headerCode('GCE.GCEINVOICE.importo_calcolo_old_trimestre')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(21)
    importo_calcolo_old_trimestre: number;
    @headerCode('GCE.GCEINVOICE.importo_calcolo_new_trimestre')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(22)
    importo_calcolo_new_trimestre: number;
    @headerCode('GCE.GCEINVOICE.importo_fatturato_l4l_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(23)
    importo_fatturato_l4l_area: number;
    @headerCode('GCE.GCEINVOICE.importo_extrabonus_dms_trimestrale_calc')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(24)
    importo_extrabonus_dms_trimestrale_calc: number;
    @headerCode('GCE.GCEINVOICE.importo_extrabonus_dms_trimestrale_hr')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(25)
    importo_extrabonus_dms_trimestrale_hr: number;
    @headerCode('GCE.GCEINVOICE.importo_target_fatturato_trimestre_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(26)
    importo_target_fatturato_trimestre_area: number;
    @headerCode('GCE.GCEINVOICE.importo_fatturato_trimestre_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(27)
    importo_fatturato_trimestre_area: number;
    @headerCode('GCE.GCEINVOICE.importo_variabile_dms_trimestre_calc')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(28)
    importo_variabile_dms_trimestre_calc: number;
    @headerCode('GCE.GCEINVOICE.importo_variabile_dms_trimestre_hr')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(29)
    importo_variabile_dms_trimestre_hr: number;
    @headerCode('GCE.GCEINVOICE.importo_target_produzione_trimestre_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(30)
    importo_target_produzione_trimestre_area: number;
    @headerCode('GCE.GCEINVOICE.importo_produzione_trimestre_area')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(31)
    importo_produzione_trimestre_area: number;
    @headerCode('GCE.GCEINVOICE.importo_bonus_dms_trimestre_calc')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(32)
    importo_bonus_dms_trimestre_calc: number;
    @headerCode('GCE.GCEINVOICE.importo_bonus_dms_trimestre_hr')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(33)
    importo_bonus_dms_trimestre_hr: number;
    @headerCode('GCE.GCEINVOICE.perc_produzione_trimestre_area')
    @inputType('number')
    @editable(true)
    @order(34)
    perc_produzione_trimestre_area: number;





    @headerCode('GCE.GCEINVOICE.gg_presenza_trimestre_calc')
    @inputType('number')
    @pattern('00')
    @order(35)
    gg_presenza_trimestre_calc: number;
    @headerCode('GCE.GCEINVOICE.gg_lavoro_trimestre')
    @inputType('number')
    @pattern('00')
    @order(36)
    gg_lavoro_trimestre: number;
    @headerCode('GCE.GCEINVOICE.gettone_giornaliero')
    @inputType('number')
    @editable(true)
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(37)
    gettone_giornaliero: number;
    @headerCode('GCE.GCEINVOICE.gg_recupero_trimestre_calc')
    @inputType('number')
    @pattern('00')
    @order(38)
    gg_recupero_trimestre_calc: number;
    @headerCode('GCE.GCEINVOICE.gg_ferie_utilizzo_trimestre')
    @inputType('number')
    @pattern('00')
    @order(39)
    gg_ferie_utilizzo_trimestre: number;
    @headerCode('GCE.GCEINVOICE.gg_ferie_anno')
    @inputType('number')
    @pattern('00')
    @order(40)
    gg_ferie_anno: number;
    @headerCode('GCE.GCEINVOICE.data_inizio_calcolo_ferie')
    @inputType('date')
    @order(41)
    data_inizio_calcolo_ferie: Date | string;
    @headerCode('GCE.GCEINVOICE.gg_ferie_utilizzate_precedenti')
    @inputType('number')
    @pattern('00')
    @order(42)
    gg_ferie_utilizzate_precedenti: number;


    person?: GceInvoicePerson;

    constructor();
    constructor(mese: Date,
        idfatturazione: number,
        ts_calcolo: Date | string,
        flg_conferma_hr: boolean,
        user_conferma_hr: string,
        ts_conferma_hr: Date | string,
        flg_cliniche_confermate: boolean,
        idarea: number,
        importo_fisso_dms_mensile_calc: number,
        importo_fisso_dms_mensile_hr: number,
        importo_target_produzione_mensile_area: number,
        importo_produzione_mensile_area: number,
        perc_produzione_mensile_area: number,
        importo_bonus_dms_mensile_calc: number,
        importo_bonus_dms_mensile_hr: number,
        importo_target_mensile_personale: number,
        importo_produzione_mensile_personale: number,
        perc_produzione_mensile_personale: number,
        importo_variabile_dms_mensile_calc: number,
        importo_variabile_dms_mensile_hr: number,
        importo_calcolo_old_trimestre: number,
        importo_calcolo_new_trimestre: number,
        importo_fatturato_l4l_area: number,
        importo_extrabonus_dms_trimestrale_calc: number,
        importo_extrabonus_dms_trimestrale_hr: number,
        importo_target_fatturato_trimestre_area: number,
        importo_fatturato_trimestre_area: number,
        importo_variabile_dms_trimestre_calc: number,
        importo_variabile_dms_trimestre_hr: number,
        importo_target_produzione_trimestre_area: number,
        importo_produzione_trimestre_area: number,
        importo_bonus_dms_trimestre_calc: number,
        importo_bonus_dms_trimestre_hr: number,
        perc_produzione_trimestre_area: number,
        gg_presenza_trimestre_calc: number,
        gg_lavoro_trimestre : number,
        gettone_giornaliero : number,
        gg_recupero_trimestre_calc : number,
        gg_ferie_utilizzo_trimestre : number,
        gg_ferie_anno: number,
        data_inizio_calcolo_ferie: Date | string,
        gg_ferie_utilizzate_precedenti : number);
    constructor(mese?: Date,
        idfatturazione?: number,
        ts_calcolo?: Date | string,
        flg_conferma_hr?: boolean,
        user_conferma_hr?: string,
        ts_conferma_hr?: Date | string,
        flg_cliniche_confermate?: boolean,
        idarea?: number,
        importo_fisso_dms_mensile_calc?: number,
        importo_fisso_dms_mensile_hr?: number,
        importo_target_produzione_mensile_area?: number,
        importo_produzione_mensile_area?: number,
        perc_produzione_mensile_area?: number,
        importo_bonus_dms_mensile_calc?: number,
        importo_bonus_dms_mensile_hr?: number,
        importo_target_mensile_personale?: number,
        importo_produzione_mensile_personale?: number,
        perc_produzione_mensile_personale?: number,
        importo_variabile_dms_mensile_calc?: number,
        importo_variabile_dms_mensile_hr?: number,
        importo_calcolo_old_trimestre?: number,
        importo_calcolo_new_trimestre?: number,
        importo_fatturato_l4l_area?: number,
        importo_extrabonus_dms_trimestrale_calc?: number,
        importo_extrabonus_dms_trimestrale_hr?: number,
        importo_target_fatturato_trimestre_area?: number,
        importo_fatturato_trimestre_area?: number,
        importo_variabile_dms_trimestre_calc?: number,
        importo_variabile_dms_trimestre_hr?: number,
        importo_target_produzione_trimestre_area?: number,
        importo_produzione_trimestre_area?: number,
        importo_bonus_dms_trimestre_calc?: number,
        importo_bonus_dms_trimestre_hr?: number,
        perc_produzione_trimestre_area?: number,
        gg_presenza_trimestre_calc?: number,
        gg_lavoro_trimestre? : number,
        gettone_giornaliero? : number,
        gg_recupero_trimestre_calc? : number,
        gg_ferie_utilizzo_trimestre? : number,
        gg_ferie_anno?: number,
        data_inizio_calcolo_ferie?: Date | string,
        gg_ferie_utilizzate_precedenti? : number) {
        super();
        this.mese = mese;
        this.idfatturazione = idfatturazione;
        this.ts_calcolo = ts_calcolo;
        this.flg_conferma_hr = flg_conferma_hr;
        this.user_conferma_hr = user_conferma_hr;
        this.ts_conferma_hr = ts_conferma_hr;
        this.flg_cliniche_confermate = flg_cliniche_confermate;
        this.idarea = idarea;
        this.importo_fisso_dms_mensile_calc = importo_fisso_dms_mensile_calc;
        this.importo_fisso_dms_mensile_hr = importo_fisso_dms_mensile_hr;
        this.importo_target_produzione_mensile_area = importo_target_produzione_mensile_area;
        this.importo_produzione_mensile_area = importo_produzione_mensile_area;
        this.perc_produzione_mensile_area = perc_produzione_mensile_area;
        this.importo_bonus_dms_mensile_calc = importo_bonus_dms_mensile_calc;
        this.importo_bonus_dms_mensile_hr = importo_bonus_dms_mensile_hr;
        this.importo_target_mensile_personale = importo_target_mensile_personale;
        this.importo_produzione_mensile_personale = importo_produzione_mensile_personale;
        this.perc_produzione_mensile_personale = perc_produzione_mensile_personale;
        this.importo_variabile_dms_mensile_calc = importo_variabile_dms_mensile_calc;
        this.importo_variabile_dms_mensile_hr = importo_variabile_dms_mensile_hr;
        this.importo_calcolo_old_trimestre = importo_calcolo_old_trimestre;
        this.importo_calcolo_new_trimestre = importo_calcolo_new_trimestre;
        this.importo_fatturato_l4l_area = importo_fatturato_l4l_area;
        this.importo_extrabonus_dms_trimestrale_calc = importo_extrabonus_dms_trimestrale_calc;
        this.importo_extrabonus_dms_trimestrale_hr = importo_extrabonus_dms_trimestrale_hr;
        this.importo_target_fatturato_trimestre_area = importo_target_fatturato_trimestre_area;
        this.importo_fatturato_trimestre_area = importo_fatturato_trimestre_area;
        this.importo_variabile_dms_trimestre_calc = importo_variabile_dms_trimestre_calc;
        this.importo_variabile_dms_trimestre_hr = importo_variabile_dms_trimestre_hr;
        this.importo_target_produzione_trimestre_area = importo_target_produzione_trimestre_area;
        this.importo_produzione_trimestre_area = importo_produzione_trimestre_area;
        this.importo_bonus_dms_trimestre_calc = importo_bonus_dms_trimestre_calc;
        this.importo_bonus_dms_trimestre_hr = importo_bonus_dms_trimestre_hr;
        this.perc_produzione_trimestre_area = perc_produzione_trimestre_area;
        this.gg_presenza_trimestre_calc=gg_presenza_trimestre_calc;
        this.gg_lavoro_trimestre=gg_lavoro_trimestre;
        this.gettone_giornaliero =gettone_giornaliero;
        this.gg_recupero_trimestre_calc=gg_recupero_trimestre_calc;
        this.gg_ferie_utilizzo_trimestre =gg_ferie_utilizzo_trimestre;
        this.gg_ferie_anno=gg_ferie_anno;
        this.data_inizio_calcolo_ferie=data_inizio_calcolo_ferie;
        this.gg_ferie_utilizzate_precedenti=gg_ferie_utilizzate_precedenti;

    }

    static getStructure(): Array<any> {
        let structure: any[] = Describer.getStructure(new GceInvoiceDms());
        structure.push(...this.getActions());
        return structure;
    }

    protected static getActions(): any[] {
        let actions: any[] = [];
        if (PermissionService.checkPermission("CGE_EFTT")) {
            let actionConfirmation = {
                action: undefined,
                callback: 'confirmInvoice',
                callbackOnForm: false,
                columnDef: 'actionConfirmation',
                disabled: false,
                header: 'GCE.GCEINVOICE.BUTTONS.CALCULATEBILLING.TOOLTIP',
                dontShowHeader: true,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: true,
                imageButton: null,
                imageTable: 'assets/img/invoice.png',
                order: 0
            };
            actions.push(actionConfirmation);

            let actionConfirmationHR = {
                action: undefined,
                callback: 'confirmInvoiceHR',
                callbackOnForm: false,
                columnDef: 'actionConfirmationHR',
                disabled: false,
                header: 'GCE.GCEINVOICE.CONFIRMATION',
                dontShowHeader: true,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: true,
                imageButton: null,
                imageTable: 'assets/img/invoice-confirm.png',
                order: 0
            };
            actions.push(actionConfirmationHR);
            
        }
        if (PermissionService.checkPermission("CGE_RPCD")) {
            let actionCalculationDetail = {
                action: undefined,
                callback: 'openDialogPerformanceCalculationDetail',
                callbackOnForm: false,
                columnDef: 'actionCalculationDetail',
                disabled: false,
                header: 'GCE.GCEINVOICE.CALCULATIONDETAIL',
                dontShowHeader: false,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: false,
                imageButton: 'assets/img/calculator-white.png',
                imageTable: 'assets/img/calculator.png',
                tooltip: 'GCE.GCEINVOICE.CALCULATIONDETAIL.TOOLTIP',
                order: 2
            }
            actions.push(actionCalculationDetail);
        }
        return actions;
    }
}